import { useMutation } from '@tanstack/react-query';
/**
 * A wrapper around useMutation that just provides the useMutation, but with the
 * ability to update in the future to use a different query library.
 */
const useAppMutation = useMutation;

export default useAppMutation;
